import { Col, View } from "@amzn/stencil-react-components/layout";
import { MessageBanner, MessageBannerType } from "@amzn/stencil-react-components/message-banner";
import React, { FC } from "react";
import { Link } from "react-router-dom";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import {
  isRetryableErrorCode,
  REPLACEMENT_ORDER_ERROR_CODE,
} from "@/services/replacement-order/replacement-order.constants";
import { DeliverySummaryBlock } from "./components/delivery-summary-block";
import { DeviceSummaryBlock } from "./components/device-summary-block";
import { REVIEW_STRING_KEYS, submitErrorKey } from "./components/review.constants";
import type { SubmitFailure } from "./review.types";

export interface ReviewStepProps {
  assetId: string;
  category: string;
  onEditDevice: () => void;
  onEditDelivery: () => void;
  submitFailure?: SubmitFailure;
}

const SubmitFailureMessage: FC<{ failure: SubmitFailure }> = ({ failure }) => {
  if (failure.code === REPLACEMENT_ORDER_ERROR_CODE.activeOrderExists && failure.existingOrderPath) {
    return (
      <>
        {getString(submitErrorKey(failure.code))}{" "}
        <Link to={failure.existingOrderPath}>{getString(REVIEW_STRING_KEYS.viewExistingOrder)}</Link>
      </>
    );
  }
  if (isRetryableErrorCode(failure.code)) {
    return <>{getString(REVIEW_STRING_KEYS.submitError)}</>;
  }
  return <>{getString(submitErrorKey(failure.code))}</>;
};

export const ReviewStep: FC<ReviewStepProps> = ({
  assetId,
  category,
  onEditDevice,
  onEditDelivery,
  submitFailure,
}) => (
  <Col gridGap="S400" width="100%">
    <DeviceSummaryBlock assetId={assetId} category={category} onEdit={onEditDevice} />
    <DeliverySummaryBlock onEdit={onEditDelivery} />
    {submitFailure && (
      <View role="alert" width="100%" data-testid="review-submit-error">
        <MessageBanner type={MessageBannerType.Error} isDismissible={false}>
          <SubmitFailureMessage failure={submitFailure} />
        </MessageBanner>
      </View>
    )}
  </Col>
);
